import { CategoryPost, IPostInfo } from '@sapientpro/sapientpro-data-models';
import classNames from 'classnames';
import { format } from 'date-fns';
import Link from 'next/link';
import styles from './ArticlesList.module.scss';
import AnimatedTitle from '../../../components/AnimatedTitle';
import Img from '../../../components/Img';
import { pathTo } from '../../../paths';

interface IArticleCardProps {
  article: IPostInfo | CategoryPost;
  vertical?: boolean;
  className?: string;
  tableView?: boolean;
  searchView?: boolean;
}

const ArticleCard = ({
  article,
  vertical,
  className,
  tableView,
  searchView,
}: IArticleCardProps) => {
  const formattedDate = article.publishDate ? format(new Date(article.publishDate), 'dd MMM yyyy') : '';
  const showCategory = (article as IPostInfo).category && tableView;
  const { author, backgroundImage } = article;
  const readTimeLabel = article.readTime ? `${article.readTime} min` : null;

  return (
    <article className={classNames(styles.articleCard, {
      [styles.vertical]: vertical,
      [styles.tableView]: tableView || searchView,
      [styles.searchView]: searchView,
    }, className)}
    >
      <Link
        href={pathTo('article', { slug: (article as IPostInfo).slug })}
        className={styles.articleImageWrapper}
        aria-label={article.title}
      >
        {backgroundImage && (
          <Img
            src={backgroundImage.url}
            alt={backgroundImage.alternativeText || 'article image'}
            width={backgroundImage.width}
            height={backgroundImage.height}
            className={styles.articleImage}
          />
        )}
      </Link>

      <div className={styles.articleDescription}>
        {showCategory
          && (
          <Link
            href={pathTo('category', { slug: (article as IPostInfo).category.slug })}
            className={styles.categoryLink}
          >
            {(article as IPostInfo).category.title}
          </Link>
          )}
        {readTimeLabel && (
          <p className={styles.readtime}>{readTimeLabel}</p>
        )}
        <h6 className={classNames(styles.title, 'header4')}>
          <Link
            href={pathTo('article', { slug: (article as IPostInfo).slug })}
          >
            <AnimatedTitle title={article.title} />
          </Link>
        </h6>
        {(article as IPostInfo)?.description && (
        <div
          className={classNames(styles.description, 'bodyLarge')}
          dangerouslySetInnerHTML={{ __html: (article as IPostInfo)?.description || '' }}
        />
        )}
        <footer className={styles.info}>
          {author && (
            <Link
              href={pathTo('author', { slug: author.slug })}
              className={styles.author}
            >
              {author.pseudonym?.split(' ')[0]}
            </Link>
          )}
          <time className={styles.date}>{formattedDate}</time>
          {readTimeLabel && (
            <p className={styles.readtime}>{readTimeLabel}</p>
          )}
        </footer>
      </div>
    </article>
  );
};

export default ArticleCard;
